<div class="hold-breakdown-sheet">
  <div class="hold-breakdown-sheet__handle"></div>
  <app-hold-breakdown-content
    [data]="data"
    (dismiss)="close()"
    (navigate)="goTo($event)"
  ></app-hold-breakdown-content>
</div>
